export enum CodeMessage {
  NO_CERVED_DATA = "NO_CERVED_DATA",
  NO_PEC = "NO_PEC",
  CANNOT_CREATE_USER = "CANNOT_CREATE_USER",
  PASSWORD_ALREADY_REQUESTED = "PASSWORD_ALREADY_REQUESTED",
  PASSWORD_REQUESTED = "PASSWORD_REQUESTED"
}
